import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("table", { id: "slide1" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, [
      /*#__PURE__*/_createElementVNode("h1", { style: {"font-size":"120%","line-height":"130%"} }, " Obtenez de nouveaux clients ! "),
      /*#__PURE__*/_createElementVNode("h2", null, " On vous aide à louer vos box vides ")
    ])
  ])
], -1)
const _hoisted_2 = { style: {"margin":"0 10px"} }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"steps\"><div style=\"flex:1;margin:1em;\"><div class=\"owner-number\"> 1 </div><div class=\"owner-title\"> Créer votre annonce </div><div class=\"owner-text\"> En quelques clics seulement votre garde meuble et vos espaces de stockage sont en ligne Remplissez le formulaire de demande d&#39;inscription. Vous serez guidés et conseillés par l&#39;un de nos experts pour définir la meilleure offre pour votre entreprise et pour optimiser sa visibilité. </div></div><div style=\"flex:1;margin:1em;\"><div class=\"owner-number\"> 2 </div><div class=\"owner-title\"> Les locataires vous contactent </div><div class=\"owner-text\"> Recevez directement des demandes de réservations, des appels téléphoniques, des demandes de rendez-vous... et louez vos box de stockage sereinement. </div></div></div>", 1)
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16pt","text-align":"center","margin":"0 auto 30px"} }, " Témoignages de propriétaires de centre de location de box de stockage individuel ", -1)
const _hoisted_6 = { style: {"display":"flex","flex-wrap":"wrap","max-width":"1200px","margin":"auto"} }
const _hoisted_7 = { class: "wrap-article" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { style: {"width":"100vw","font-size":"13pt","text-align":"center","margin":"30px auto 30px","background":"#1C5BA3","padding":"40px","color":"white"} }
const _hoisted_11 = { style: {"width":"100%","max-width":"1200px","margin":"auto","line-height":"130%"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Location-gardemeuble.fr rassemble le plus grand nombre de centres de box à louer en France en un seul endroit. Plus de 700 garde-meubles et centres de self-stockage sont déjà inscrits et bénéficient de nos avantages (forte visibilité, taux de conversion élevé, excellent retour sur investissement...) ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Si vous voulez gagner des clients au meilleur prix, ")
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div style=\"margin:0 10px;\"><div style=\"width:100%;max-width:1200px;line-height:130%;margin:80px auto;text-align:center;font-size:14pt;\"><b>Une question ?</b> Contactez un de nos conseillers <a href=\"mailto:contact@location-gardemeuble.fr\" style=\"color:#2A88FF !important;\">contact@location-gardemeuble.fr</a></div><div style=\"width:100%;max-width:1000px;line-height:160%;margin:80px auto 30px;text-align:justify;font-size:12pt;\"><span style=\"text-decoration:underline;\">Vous manquez de temps ou vous ne souhaitez pas vous occuper des locations ?</span> Nous avons également une équipe dédiée pour gérer votre centre de box self-stockage autonomes. Renseignez-vous auprès de nos conseillers pour la gestion de vos appels téléphoniques, visites, contrat de location, paiement... </div></div>", 1)
const _hoisted_17 = { class: "overlay" }
const _hoisted_18 = {
  class: "contact-form",
  id: "form-anchor",
  style: {"max-width":"400px"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("b", null, "Demande d'inscription", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { style: {"color":"white","text-align":"center","display":"block"} }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { style: {"display":"block","text-align":"left"} }, "Votre nom et prénom", -1)
const _hoisted_24 = { style: {"color":"white","text-align":"center","display":"block"} }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { style: {"display":"block","text-align":"left"} }, "Votre adresse e-mail", -1)
const _hoisted_26 = { style: {"color":"white","text-align":"center","display":"block"} }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { style: {"display":"block","text-align":"left"} }, "Votre téléphone", -1)
const _hoisted_28 = { style: {"color":"white","text-align":"center","display":"block"} }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { style: {"display":"block","text-align":"left"} }, "Votre enseigne", -1)
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  style: {"width":"100%","margin":"25px auto auto"},
  type: "submit",
  value: "Envoyer"
}
const _hoisted_32 = { style: {"text-align":"center","margin-bottom":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header),
    _createElementVNode("section", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "button-block",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {this.modal = true;})
          }, " Demande d'inscription ")
        ]),
        _hoisted_5,
        _createElementVNode("section", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.articles, (article) => {
            return (_openBlock(), _createElementBlock("article", _hoisted_7, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: 'https://api.location-gardemeuble.fr/img/upload/site/'+article.gm_id+'/thumb/image_1.jpg',
                  alt: article.title,
                  width: "75",
                  height: "75"
                }, null, 8, _hoisted_8),
                _createElementVNode("h2", null, [
                  _createTextVNode(_toDisplayString(article.author) + " ", 1),
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(article.gm), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", null, _toDisplayString(article.text), 1)
              ])
            ]))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _hoisted_14,
          _hoisted_15,
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => {this.modal = true;}),
            style: {"cursor":"pointer","text-decoration":"underline"}
          }, "demandez à faire apparaître vos boxes garde-meubles maintenant.")
        ])
      ]),
      _hoisted_16
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("form", {
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (this.submit && this.submit(...args)), ["prevent"])),
              method: "post"
            }, [
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _createElementVNode("label", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  style: {"width":"100%","margin":"3px auto 15px"},
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.name]
                ])
              ]),
              _createElementVNode("label", _hoisted_24, [
                _hoisted_25,
                _withDirectives(_createElementVNode("input", {
                  style: {"width":"100%","margin":"3px auto 15px"},
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.email]
                ])
              ]),
              _createElementVNode("label", _hoisted_26, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  style: {"width":"100%","margin":"3px auto 15px"},
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.phone) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.phone]
                ])
              ]),
              _createElementVNode("label", _hoisted_28, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  style: {"width":"100%","margin":"3px auto 15px"},
                  type: "text",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.owner) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.formData.owner]
                ])
              ]),
              _withDirectives(_createElementVNode("div", {
                innerHTML: this.error,
                style: _normalizeStyle({lineHeight: '1.5em', background: (this.success ? 'green' : 'darkred'), borderRadius: '5px', padding: '0.5em', margin: 'auto'})
              }, null, 12, _hoisted_30), [
                [_vShow, this.error]
              ]),
              _withDirectives(_createElementVNode("input", _hoisted_31, null, 512), [
                [_vShow, !this.loading && !this.success]
              ]),
              _withDirectives(_createElementVNode("div", null, " Envoi en cours ... ", 512), [
                [_vShow, this.loading]
              ])
            ], 32),
            _withDirectives(_createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", {
                style: {"color":"white","cursor":"pointer","background":"rgba(0,0,0,0.5)","padding":"0.5em","margin":"0 20px"},
                onClick: _cache[7] || (_cache[7] = ($event: any) => {this.modal = false;})
              }, _toDisplayString(this.success ? "Revenir au site" : "Annuler"), 1)
            ], 512), [
              [_vShow, !this.loading]
            ])
          ])
        ], 512), [
          [_vShow, this.modal]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Footer)
  ]))
}